<template>
  <div class="scroll_flex_container">
    <storeBanner :store="storeName" :showVipCard="true"></storeBanner>
    <tableOrder
      @click="toOrderPage"
      v-if="isLogin && isAreaIdValid && isTableIndexValid"
    ></tableOrder>
    <loginCard class="mt-5" v-else-if="!isLogin" @login="lineLogin"></loginCard>
    <storeInfoDetail v-if="isLogin"></storeInfoDetail>
    <!-- <button v-if="!isLogin" class="button my-4" style="width: 92vw; background-color: #fff"
      @click="toMemberPage">返回VIP會員卡</button> -->

    <!-- 新增：店家公告跳窗組件 -->
    <StoreNoticePopup />
  </div>
</template>

<script>
import storeBanner from "../../components/store/storeBanner.vue";
import storeInfoDetail from "../../components/store/storeInfoDetail.vue";
import tableOrder from "../../components/store/tableOrder.vue";
import loginCard from "@/components/store/loginCard.vue";
import apiData from "@/services/apiData";
import commonUtilities from "@/utils/common.utils";
import auth from "@/utils/auth.utils";
import StoreNoticePopup from "@/components/general/storeNoticePopup.vue";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    storeInfoDetail: storeInfoDetail,
    tableOrder: tableOrder,
    storeBanner: storeBanner,
    loginCard: loginCard,
    StoreNoticePopup,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("basic", {
      errorLoginState: "errorLoginState",
      errorLoginMessage: "errorLoginMessage",
      storeName: "storeName",
      googleSheetId: "googleSheetId",
    }),
    ...mapState("basic", {
      currentStore: "currentStore",
    }),
    ...mapGetters("userData", {
      isLogin: "isLogin",
      isStoreMember: "isStoreMember",
      storeCode: "storeCode",
      accessToken: "accessToken",
    }),
    ...mapGetters("line", {
      lineAccessToken: "accessToken",
    }),
    getUrlParameters() {
      return this.$route.params;
    },
    routerStoreCode() {
      return this.getUrlParameters.store;
    },
    dineInTables() {
      return this.$store.getters["spreadsheet/dineInTables"];
    },
    table() {
      return this.$store.getters["spreadsheet/tableName"](
        this.areaId,
        this.tableIndex
      );
    },
    areaId() {
      return this.getUrlParameters.areaId;
    },
    tableIndex() {
      return this.getUrlParameters.tableIndex === undefined ||
        this.getUrlParameters.tableIndex == ""
        ? -1
        : this.getUrlParameters.tableIndex;
    },
    isAreaIdValid() {
      return this.$store.getters["spreadsheet/isAreaIdValid"](this.areaId);
    },
    isTableIndexValid() {
      return this.$store.getters["spreadsheet/isTableIndexValid"](
        this.areaId,
        this.tableIndex
      );
    },
  },
  watch: {
    async errorLoginState(state) {
      if (state) {
        //關閉 loading 彈窗
        commonUtilities.closeLoading();
        let errorMessage = this.errorLoginMessage;
        if (errorMessage === "IdToken expired.") {
          this.$store.commit("line/setLineLoginData", {});
          auth.logout();
          return;
        }
        if (errorMessage == "No Such Store") {
          errorMessage = "查無此店家";
        }
        commonUtilities.createToast(
          "error",
          "點餐頁LINE登入失敗，請稍後再試",
          errorMessage
        );

        auth.logout();
      }
    },
  },
  async mounted() {
    await this.init();
  },
  methods: {
    async init() {
      let loginProcess = false;
      // 重置商店菜單資料
      await this.$store.dispatch("spreadsheet/clearData", []);
      this.$store.commit("order/setOrderSpecs", []);
      // 重置商店資訊
      this.$store.commit("basic/setStoreInfo", {});
      /*
        如果有 line access token 則進行 okShopLogin
        登入後判斷是否為該商店會員 若不是商店會員則直接幫用戶加入會員
      */
      if (!this.isLogin && this.lineAccessToken) {
        loginProcess = true;
        // 顯示讀loading 彈窗
        commonUtilities.createLoading("資料讀取中", "請稍後");
        try {
          await auth.okShopLogin();
        } catch (e) {
          // Add By Bryant 2025042901 //
          commonUtilities.closeLoading();
          // Add By Bryant 2025042901 End //
          console.error("Failed to login gen2 pos system:", e);
          this.$store.dispatch("basic/setErrorLogin", {
            state: true,
            message: e,
          });
          return;
        }
      } else if (!this.accessToken) {
        // 如果沒有 okshop access token || line access token 則不進行任何動作
        // Add By Bryant 2025050801 //
        commonUtilities.closeLoading();
        // Add By Bryant 2025050801 End //
        return;
      }

      try {
        if (!commonUtilities.isLoadingShow()) {
          commonUtilities.createLoading("資料讀取中", "請稍後");
        }
        // 如果目前 routerStoreCode 與 storeCode 不同，則需要使用切換商店 api
        if (this.routerStoreCode !== this.storeCode) {
          await this.$store.dispatch("userData/changeStore", {
            store_code: this.routerStoreCode,
          });
        }
        // 如果不是該商店會員 則進行加入會員
        if (!this.isStoreMember) {
          await this.$store.dispatch("userData/joinMember");
        }
        this.$store.commit("cart/setTableData", {});
        this.$store.commit("cart/setTakeOutTableData", {});
        // 重置購物車資料
        this.$store.commit("cart/setCart", []);
        this.$store.commit("cart/setIsPointUsed", false);
        this.$store.commit("cart/setPoints", 0);
        // 重置會員資料
        this.$store.commit("userData/setMemberInfo", {});
        // 取得商店資訊
        await this.$store.dispatch("basic/fetchStoreInfo");
        // banner 店家圖片於背景載入（需在切換商店之後）
        this.$store.dispatch("basic/fetchStoreImages");
        // 取得會員資訊
        await this.$store.dispatch("userData/fetchMemberInfo");
        // 取得桌號資料（DB 優先，無資料時 fallback 至 Google Sheets）
        await this.$store.dispatch("spreadsheet/loadDineInTables");
        // 取得支付設定列表
        await this.$store.dispatch("payment/getPaymentMethods");
        // 需要判斷桌號資料是否正確，如果不正確需跳轉到內用選擇桌號頁面
        if (!this.isAreaIdValid || !this.isTableIndexValid) {
          this.$router.replace({
            name: "onlineOrder",
            params: { store: this.storeCode },
          });
          return;
        }
        // 剩餘資料可在背景讀取
        this.$store.dispatch("userData/fetchPointHistory");
        commonUtilities.closeLoading();
        if (loginProcess) {
          await commonUtilities.delay(300);
          commonUtilities.createToast("success", "登入成功", "");
        }
      } catch (e) {
        console.error(e);
        commonUtilities.closeLoading();
        await commonUtilities.delay(300);
        commonUtilities.createToast("error", `${e}`);
      }
    },
    async toOrderPage() {
      if (!this.isLogin) {
        await this.init();
        return;
      }

      const process = "ordering";
      const method = "dineIn";
      // 設定 payment 用餐模式
      await this.$store.commit("cart/setPayment", {
        ...this.$store.state.cart.payment,
        consumptionPattern: 0,
      });
      const data = {
        tableName: this.table,
        areaId: this.areaId,
        tableIndex: this.tableIndex,
      };
      this.$store.commit("cart/setTableData", data);
      this.$router.push({
        path: `/${this.routerStoreCode}/${process}/${method}/${this.areaId}/${this.tableIndex}`,
        query: { orderSource: "tableOrder" },
      });
    },
    toMemberPage() {
      this.$router.push(`/${this.routerStoreCode}`);
    },
    lineLogin() {
      const data = new apiData();
      data.store = this.routerStoreCode;
      let path = `table/${this.areaId}/${this.tableIndex}`;
      data.data = {
        method: path,
      };
      this.$store.dispatch("line/login", data);
    },
  },
};
</script>

<style lang="scss"></style>
